import {initSheepLogo} from "./sheepLogo/sheepLogo";

window.onload = function(){
    initSheepLogo();
}